<template>
  <common-dialog ref="dialog" :title="title" width="1200px" @closed="onClosed" class="stComDialog">
    <el-table size="mini" :data="data" stripe border>
      <!-- <el-table-column prop="TermName" label="学期" min-width="130px" /> -->
      <el-table-column prop="StudentNumber" label="学生编号" min-width="120px" />
      <el-table-column prop="FullName" label="姓名" min-width="120px" />
      <el-table-column prop="CardNumber" label="卡号" min-width="120px" />
      <!-- <el-table-column prop="CurrentSeatNumber" label="当前座位号" min-width="120px" /> -->
      <!-- <el-table-column prop="CurrentClassName" label="当前班级" min-width="110px" /> -->
      <!-- <el-table-column prop="CurrentDormitory" label="当前宿舍" min-width="120px" /> -->
      <el-table-column prop="ParentName1" label="家长姓名1" min-width="120px" />
      <el-table-column prop="Alias1" label="称呼1" min-width="120px" />
      <el-table-column prop="ContactNumber1" label="联系电话1" min-width="120px" />
      <el-table-column prop="ParentName2" label="家长姓名2" min-width="120px" />
      <el-table-column prop="Alias2" label="称呼2" min-width="120px" />
      <el-table-column prop="Call2" label="联系电话2" min-width="120px" />
      <el-table-column prop="ParentName3" label="家长姓名3" min-width="120px" />
      <el-table-column prop="Alias3" label="称呼3" min-width="120px" />
      <el-table-column prop="ContactNumber3" label="联系电话3" min-width="120px" />
      <el-table-column prop="ShortNum" label="学生短号" width="90"/>
      <el-table-column prop="Balance" label="充值余额" width="90"/>
      <el-table-column prop="GiveBalance" label="赠送金额" width="90"/>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/st/student").default,
      data: [],
      params: {},
      title: "导出 学生信息",
    };
  },
  methods: {
    getData(params) {
      this.params = params;
      this.$refs.dialog.isLoading = true;
      this.api.list(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>
<style lang="scss">
.stComDialog{
  .el-dialog__body > div {
    width: fit-content;
    padding-right: 30px;
  }
}
</style>